import React, {Fragment} from 'react'
import {Route, useParams, useRouteMatch, Switch, Redirect} from 'react-router-dom'
import Flash from 'admin/components/shared/Flash'
import Tabs from 'admin/components/shared/Tabs'
import Services from '../Services'
import Alerts from '../Alerts'

export default () => {
  const {organisationID} = useParams()
  const match = useRouteMatch()

  return (
    <Fragment>
      <Flash />
      <Alerts section={true} types={['ip_sheet']} />
      <Tabs
        collection={[
          {label: 'Pending', to: `/orgs/${organisationID}/services/pending`},
          {label: 'Active', to: `/orgs/${organisationID}/services/active`},
          {label: 'Inactive', to: `/orgs/${organisationID}/services/inactive`}
        ]}
      />
      <Switch>
        <Redirect exact path={match.path} to={`/orgs/${organisationID}/services/active`} />
        <Route path={`${match.path}/:status`} component={Services} />
      </Switch>
    </Fragment>
  )
}
